import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";

export function linearIssueLabel(verb: string, issue: unknown): ToolActivity {
  const id = toolInput.trimmed(issue);
  return labelOnly(id ? `${verb} ${id}` : verb);
}
